import { DefaultState } from 'store/types';
import { ReadyForAssignmentData } from '../get-ready-for-assignment-data/types';

export const SELECTED_FOR_MASS_BOOKING_REQUEST = 'SELECTED_FOR_MASS_BOOKING_REQUEST';
export const SELECTED_FOR_MASS_BOOKING_SUCCESS = 'SELECTED_FOR_MASS_BOOKING_SUCCESS';
export const SELECTED_FOR_MASS_BOOKING_FAILURE = 'SELECTED_FOR_MASS_BOOKING_FAILURE';

export interface SelectedForMassBookingData {
  rows: ReadyForAssignmentData[];
  minFromDate: string;
  maxToDate: string;
  address: string;
}

export type SelectedForMassBookingState = DefaultState & {
  contents?: SelectedForMassBookingData;
};

interface ReadSelectedForMassBookingRequest {
  type: typeof SELECTED_FOR_MASS_BOOKING_REQUEST;
}

interface ReadSelectedForMassBookingSuccess {
  type: typeof SELECTED_FOR_MASS_BOOKING_SUCCESS,
  contents: SelectedForMassBookingData;
}

interface ReadSelectedForMassBookingFailure {
  type: typeof SELECTED_FOR_MASS_BOOKING_FAILURE;
}

export type SelectedForMassBookingActionTypes = ReadSelectedForMassBookingRequest | ReadSelectedForMassBookingSuccess | ReadSelectedForMassBookingFailure;
